var render = function render(){var _vm=this,_c=_vm._self._c;return _c('scroll-bar',[_c('el-menu',{attrs:{"unique-opened":"","mode":"vertical","default-active":_vm.$route.path,"collapse":_vm.isCollapse,"background-color":"#304156","text-color":"#bfcbd9","active-text-color":"#409EFF"}},[_c('sidebar-item',{attrs:{"routes":_vm.menuList}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }